import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { CenterInterceptor } from "@api/interceptors/center/center.interceptor";
import { ErrorInterceptor } from "@api/interceptors/error.interceptor";
import { LoaderInterceptor } from "@api/interceptors/loader.interceptor";
import { TokenInterceptor } from "@api/interceptors/token.interceptor";

export const provideCustomInterceptors = () => {
    return [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoaderInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CenterInterceptor,
            multi: true,
        },
    ];
};
